<template>
  <div id="app">
    <header-ms :is-show-record = "isShowRecord" @sightless="sightless = true"/>
    <router-view @showRecord="isShowRecord=!isShowRecord" />
    <footer-ms @sightless="sightless = true"/>
    <modal-form class="sightless" v-if="sightless">
      <sightless-ms @close="sightless = false"></sightless-ms>
    </modal-form>
    <div  class="frame-padding cookies" v-if="isCookies">
      <panel-ms>
        <div>
          <p>
            Для улучшения работы сайта и его взаимодействия с пользователями используются файлы cookie и сервисы веб-аналитики.
            Продолжая работу с сайтом, Вы даете разрешение на использование cookie-файлов и согласие на обработку данных сервисами Яндекс.Метрика.
          </p>
          <p>
            Вы всегда можете отключить файлы cookie в настройках Вашего браузера.
          </p>
          <p>
            <a target="_blank" href="https://mosp51.ru/files/doc/Политика_в_отношении_обработки_и_защиты_ПДн.pdf">
              Политика в отношении обработки и защиты персональных данных.
            </a>
          </p>
        </div>
        <div class="button"  >
          <button-ms @click="setCooke()">Принять</button-ms>
        </div>
      </panel-ms>
    </div>    
  </div>
</template>

<script>
import FooterMs from './components/FooterMs.vue';
import HeaderMs from './components/HeaderMs.vue';
import modalForm from './components/common/modalFormMs.vue';
import sightlessMs from './components/common/sightlessMs.vue'
import panelMs from './components/common/panelMs.vue';
import buttonMs from './components/common/buttonMs.vue';
export default {
  components:{
    panelMs,
    HeaderMs,
    FooterMs,
    sightlessMs,
    modalForm,
    buttonMs,
  },
  mounted(){
    document.title = 'МОСП «Мурманская областная стоматологическая поликлиника»'
    this.checkCooke()
  },
  methods:{

    checkCooke(){
      console.log('PCCK')
      let PCCK = new Date(localStorage.getItem('PCCK')*1000)
      if (!(PCCK instanceof Date) || isNaN(PCCK.getTime())) {
        this.isCookies = true;
        return false
      }
      PCCK.setDate(PCCK.getDate() + 14)
      console.log(PCCK,'PCCK2')
      if (PCCK<Date.now()){
        this.isCookies = true;
        return false
      }
      this.isCookies = false;
    },
    setCooke(){ 
      localStorage.setItem('PCCK',Date.now())
      this.isCookies = false;
    }
  },
  data(){
    return{
      isShowRecord:false,
      sightless:false,
      isCookies:true,
    }
  }
}
</script>

<style>
@import url(https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap);
@import url(https://fonts.google.com/share?selection.family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900);
:root{
  --background:#FAFDFF;
  --white:#FFF;
}
html.blue1{
  --background:#007BB8;
  --white:#9DD9FF;
}
html {
  scroll-behavior: smooth;
}
body {
  background-color: var(--background);
  font-family: Rubik,sans-serif;
  margin: 0;
}
.frame-padding {
  width: 100%;
}
.frame-padding > div {
  max-width: 1320px;
  margin: auto;
}
h2, h3 {
  font-weight: 500;
}
h2 {
  margin: 0 0 40px 0;
  font-size: 32px;
  color: #0d3041;
}

.sightless .modal-form {
  max-width: 492px;
  height: 649px;
  border-radius: 15px;
  width: 100%;
  overflow: auto;
}
@media (max-width: 1000px) {
  h2 {
    font-size: 26px;
    margin: 0 0 32px 0;
  }
}

.medium0 * {
  font-size: 22px !important;
}
.big0 * {
  font-size: 26px !important;
}
.inversion1 {
  filter: invert(1);
}
.inversion1 img {
  filter: invert(1);
}
.medium2 * {
  letter-spacing: 4px !important;
}
.big2 * {
  letter-spacing: 8px !important;
}
.medium3 * {
  line-height: 165% !important;
}
.big3 * {
  line-height: 200% !important;
}

.cookies{
  position: fixed;
  bottom: 0px;
  z-index: 20000;
  width: 100%;
  display: flex;
}
.cookies .panel{
  padding: 20px;
  display: flex;
  gap: 30px;
}
.cookies .panel .button {
  display: flex;
  align-items: center;
}

</style>